import { getMessageList, readMessage, hasUnReadMessage, homeMessageTips } from '@/api/message'

const state = {
  messageList: [],
  totalCount: 0,
  hasUnRead: false,
  homeMessage: ''
}

const mutations = {
  // 设置 消息列表
  SET_MESSAGE_LIST: (state, { list }) => {
    state.messageList = list
  },
  SET_TOTAL_COUNT: (state, count) => {
    state.totalCount = count
  },
  // 设置 消息列表中的项为已读
  SET_MESSAGE_READ: (state, id) => {
    state.messageList = state.messageList.map(value => {
      if (value.id === id) {
        value.readStatus = 1
      }
      return value
    })
  },
  SET_HAS_UN_READ: (state, payload) => {
    state.hasUnRead = payload
  },
  SET_HOME_MESSAGE_TIP: (state, message) => {
    state.homeMessage = message
  }
}

const actions = {
  // 获取消息列表
  async getMessageList({ commit }, param) {
    const { pageNo, pageSize } = param
    const response = await getMessageList({ pageNo, pageSize })
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_MESSAGE_LIST', { list: data.result })
      commit('SET_TOTAL_COUNT', +data.totalCount)
    } else {
      commit('SET_MESSAGE_LIST', { list: [] })
      commit('SET_TOTAL_COUNT', 0)
    }
    return response
  },
  // 消息设为读取
  async readMessage({ commit }, param) {
    const { id } = param
    const response = await readMessage({ id })
    const { code } = response.data
    if (code === 0) {
      commit('SET_MESSAGE_READ', id)
    }
    return response
  },
  async getHasUnReadMessage({ commit }, param) {
    const response = await hasUnReadMessage()
    const { data } = response.data
    commit('SET_HAS_UN_READ', data)
    return response
  },
  async homeMessageTips({ commit, state }, params) {
    const response = await homeMessageTips(params)
    const { data } = response
    if (data && data.code === 0 && data.data) {
      commit('SET_HOME_MESSAGE_TIP', state.homeMessage + '  ' + data.data)
    }
    return response
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
